import { noteContainsString } from '../../Note/utils/noteContainsString.mjs'

export function researchSourceContainsString(
  source,
  searchString,
  notesMap = {},
) {
  if (!source || !source.noteIds || !searchString) return false

  return (
    source.title?.toLowerCase().includes(searchString.trim()) ||
    source.url?.toLowerCase().includes(searchString.trim()) ||
    source.noteIds.some((noteId) =>
      noteContainsString(notesMap[noteId], searchString),
    )
  )
}
